import Sb from "../abstract/StatefulBehavior";
import createActivityDetector from "activity-detector";

export default class NotificationModal extends Sb {
  constructor(el, props, refs) {
    super();

    this.el = el;
    this.refs = refs;
    this.state = {
      closed: false,
    };
    this.props = props;

    this.sessionKey = "hideNotificationModalMMC";
    this.activityDetector = null;
    this.openOnIdle = this.el.dataset.openOnIdle === "true";

    // if UA doesn't support localStorage or blocks access to it, bail
    try {
      const hasLocalSession = this.hasLocalSession();
      const isInternalNavigation = this.isInternalNavigation();

      if (hasLocalSession) {
        this.hideElement();
        this.state.closed = hasLocalSession;
      } else if (!this.openOnIdle || isInternalNavigation) {
        this.el.showModal();
        document.body.classList.add("has-scroll-lock");
      }
    } catch (error) {
      // eslint-disable-next-line
      console.warn("Your browser does not support local session keys.");
    }

    if (this.openOnIdle && !this.el.open) {
      this.activityDetector = createActivityDetector({
        timeToIdle: 10000,
        inactivityEvents: ["visibilitychange"],
      });
    }

    this.update();
    this.bindEvents();
  }

  update = () => {
    const { closed } = this.state;
    if (closed) {
      this.hideElement();
    } else if (!this.openOnIdle) {
      this.el.showModal();
    }
  };

  hasLocalSession() {
    const localSession = localStorage.getItem(this.sessionKey);
    let hasLocalSession = false;

    if (localSession) {
      const session = JSON.parse(localSession);

      // Reset local session for new modals or if session expired
      if (
        session.heading === this.props.heading &&
        new Date(session.expirationDate) > new Date()
      ) {
        hasLocalSession = true;
      } else {
        localStorage.removeItem(this.sessionKey);
      }
    }

    return hasLocalSession;
  }

  isInternalNavigation() {
    if (window.location.pathname === "/search") {
      return false;
    }

    if (!document.referrer) {
      return false;
    }

    try {
      return new URL(document.referrer).origin === window.location.origin;
    } catch (error) {
      return false;
    }
  }

  bindEvents() {
    this.refs.toggleClosed.addEventListener("click", this.closeNotification);
    this.refs.ctaButton.addEventListener("click", this.closeNotification);
    this.el.addEventListener("click", this.handleClick);
    window.addEventListener("keyup", this.handleKeyUp);
    window.addEventListener("pageshow", this.handlePageShow);

    if (this.activityDetector && !this.state.closed) {
      this.activityDetector.on("idle", this.showModalOnIdle);
    }
  }

  handlePageShow = (event) => {
    if (!event.persisted) {
      return;
    }

    if (this.hasLocalSession()) {
      this.state.closed = true;
      this.hideElement();
    }
  };

  showModalOnIdle = () => {
    const { closed } = this.state;
    if (!closed) {
      this.el.showModal();
    }
  };

  handleClick = (event) => {
    const isClickInside = this.refs.dialog.contains(event.target);

    if (!isClickInside) {
      this.closeNotification();
    }
  };

  handleKeyUp = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const { key, keyCode, which } = event;

    if (key === "Escape" || key === "Esc" || keyCode === 27 || which === 27) {
      this.closeNotification();
    }
  };

  closeNotification = () => {
    const expirationDate = new Date();
    expirationDate.setDate(
      expirationDate.getDate() + this.props.dismissExpiration
    );

    localStorage.setItem(
      this.sessionKey,
      JSON.stringify({
        expirationDate,
        heading: this.props.heading,
      })
    );
    this.setState({ closed: true });
    window.removeEventListener("keyup", this.handleKeyUp);
  };

  hideElement = () => {
    this.el.close();
    document.body.classList.remove("has-scroll-lock");

    if (this.activityDetector) {
      this.activityDetector.stop();
    }
  };
}
